import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { DxHttpModule } from 'devextreme-angular/http';

import { AppComponent } from './app.component';
import { SideNavOuterToolbarModule, SingleCardModule } from './layouts';
import {
	AppFooterModule,
	ResetPasswordFormModule,
	CreateAccountFormModule,
	ChangePasswordFormModule,
	LoginFormModule,
} from './components';

import { AuthService, ScreenService, AppInfoService } from './services';
import { AuthInterceptor } from './services/auth-interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { UnauthenticatedContentModule } from './layouts/unauthenticated-content/unauthenticated-content';
import { AppRoutingModule } from './app-routing.module';
import { CrmContactListModule } from './pages/crm-contact-list/crm-contact-list.component';
import { CrmContactDetailsModule } from './pages/crm-contact-details/crm-contact-details.component';
import { PlanningTaskListModule } from './pages/planning-task-list/planning-task-list.component';
import { PlanningTaskDetailsModule } from './pages/planning-task-details/planning-task-details.component';
import { AnalyticsDashboardModule } from './pages/analytics-dashboard/analytics-dashboard.component';
import { AnalyticsSalesReportModule } from './pages/analytics-sales-report/analytics-sales-report.component';
import { AnalyticsGeographyModule } from './pages/analytics-geography/analytics-geography.component';
import { ThemeService } from './services';
import { JwtHelperService } from '@auth0/angular-jwt';
import { JwtModule } from '@auth0/angular-jwt';
import { StorageService } from './services/storage.service';
import { inject } from '@angular/core';

export function tokenGetter(): string {
	const storageService = inject(StorageService);
	return storageService.getToken();
}

@NgModule({
	declarations: [
		AppComponent,
	],
	imports: [
		BrowserModule,
		DxHttpModule,
		SideNavOuterToolbarModule,
		SingleCardModule,
		AppFooterModule,
		ResetPasswordFormModule,
		CreateAccountFormModule,
		ChangePasswordFormModule,
		LoginFormModule,
		UnauthenticatedContentModule,
		JwtModule.forRoot({
			config: {
				tokenGetter: tokenGetter,
//			  allowedDomains: ['your-api-domain.com'], // Az API domainje
//			  disallowedRoutes: ['your-api-domain.com/auth/login'], // Kivételek
			},
		}),
		CrmContactListModule,
		CrmContactDetailsModule,
		PlanningTaskListModule,
		PlanningTaskDetailsModule,
		AnalyticsDashboardModule,
		AnalyticsSalesReportModule,
		AnalyticsGeographyModule,

		AppRoutingModule,
	],
	providers: [
		AuthService, 
		ScreenService, 
		AppInfoService, 
		{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
		JwtHelperService,
		ThemeService,
		StorageService,
	],
	bootstrap: [AppComponent],
})
export class AppModule { }
